export default "__VITE_ASSET__Sv4TBbYJ__"